import { render, staticRenderFns } from "./RangeTableInfo.vue?vue&type=template&id=0c45028f&scoped=true&"
import script from "./RangeTableInfo.vue?vue&type=script&lang=js&"
export * from "./RangeTableInfo.vue?vue&type=script&lang=js&"
import style0 from "./RangeTableInfo.vue?vue&type=style&index=0&id=0c45028f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45028f",
  null
  
)

export default component.exports